module.exports = __webpack_public_path__ + "img/support.7afc5fb0.png";